import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  deviceTransferFunction() {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-使用功能',
      eventCategory: 'HIK-Connect设备迁移'
    });
  },
  deviceTransferLoginHC() {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-完成登陆HC账号',
      eventCategory: 'HIK-Connect设备迁移'
    });
  },
  deviceTransferDeviceFilter(index) {
    const type = {
      0: '显示全部设备',
      1: '仅显示你的设备',
      2: '仅显示别人分享的设备'
    };

    buryPoint.event({
      action: 'HIK-Connect设备迁移-设备筛选',
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel: type[index]
    });
  },
  deviceChoiceComplete() {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-完成设备选择',
      eventCategory: 'HIK-Connect设备迁移'
    });
  },
  deviceChoiceTime(time, eventLabel) {
    buryPoint.timing({
      name: 'HIK-Connect设备迁移-设备选择时长',
      value: time,
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel
    });
  },
  deviceTransferSiteNameEdit() {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-编辑站点名称',
      eventCategory: 'HIK-Connect设备迁移'
    });
  },
  deviceTransferApplyAuth(type, count) {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-编辑设备申请权限',
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel: type === 'CONFIG' ? `去勾选配置权限数量：${ count}` : `勾选预览权限数量：${ count}`
    });
  },
  siteConfigComplete() {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-完成站点配置',
      eventCategory: 'HIK-Connect设备迁移'
    });
  },
  siteConfigTime(time, eventLabel) {
    buryPoint.timing({
      action: 'HIK-Connect设备迁移-站点配置时长',
      eventCategory: 'HIK-Connect设备迁移',
      value: time,
      eventLabel: eventLabel
    });
  },
  deviceTransferResult(index) {
    const type = {
      0: '安装商设备已全部完成迁移',
      1: '安装商设备部分完成迁移',
      2: '安装商设备全部迁移失败',
      3: '创建站点失败'
    };
    buryPoint.event({
      action: 'HIK-Connect设备迁移-安装商设备迁移结果',
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel: type[index]
    });
  },
  deviceTransferDeviceResult(isSuccess, count) {
    buryPoint.event({
      action: 'HIK-Connect设备迁移-设备数量',
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel: isSuccess ? `迁移成功的设备数量：${ count}` : `迁移失败的设备数量：${ count}`
    });
  },
  deviceTransferTime(time) {
    buryPoint.timing({
      action: 'HIK-Connect设备迁移-迁移任务时长',
      eventCategory: 'HIK-Connect设备迁移',
      value: time
    });
  },
  deviceTransferEntrance(where) {
    const op = {
      1: '用户信息下拉框',
      2: '主页常用功能',
      3: '站点列表',
      4: '主页Banner',
      5: '添加结果页总入口',
      6: '添加结果页设备操作栏',
      7: '手动添加提示文案',
      8: '迁移结果页-"继续迁移"'
    };
    buryPoint.event({
      action: 'HIK-Connect设备迁移-入口',
      eventCategory: 'HIK-Connect设备迁移',
      eventLabel: op[where]
    });
  },
  hcAuthExpired() {
    buryPoint.event({
      action: 'Hik-Connect设备迁移-HC授权过期',
      eventCategory: 'Hik-Connect设备迁移'
    });
  },
  hcLoginOpen(flag) {
    const op = {
      1: '正常',
      2: '授权已过期，请重新登录'
    };
    buryPoint.event({
      action: 'Hik-Connect设备迁移-HC授权登陆',
      eventCategory: 'Hik-Connect设备迁移',
      eventLabel: op[flag]
    });
  }
};
